import { Component, Inject, OnInit } from '@angular/core';
import { IBlindLevelAndResumeDate } from '@soposopo/sopo-models/dist/tournament/Tournament.state';
import moment from 'moment';
import { SOPO_DIALOG_DATA, SopoDialogRef } from '../../interfaces/dialog';

export interface SopoMultiDayData {
    blinds: string[];
    disabledToIndex: number;
    minTimeString: string;
    cancelText?: string;
    okText?: string;
}

@Component({
    selector: 'app-multi-day-settings-input',
    templateUrl: './sopo-multi-day-settings-input.component.html',
    styleUrls: ['./sopo-multi-day-settings-input.component.scss'],
    standalone: false
})
export class SopoMultiDaySettingsInputComponent implements OnInit {
    resumeDate = '';
    minTimeIsoString = '';
    maxTimeIsoString = '';
    blinds: string[] = [];
    disabledToIndex: number;
    blind: string;
    

    cancelText: string;
    okText: string;

    constructor(
        private sopoDialogRef: SopoDialogRef,
        @Inject(SOPO_DIALOG_DATA) data: SopoMultiDayData,
    ) {
        if (data.blinds !== undefined) this.blinds = data.blinds;
        if (data.disabledToIndex !== undefined) {
            this.disabledToIndex = data.disabledToIndex;
            this.blinds.splice(0, this.disabledToIndex + 1);
        }
        this.okText = data.okText ? data.okText : 'Confirm';
        this.cancelText = data.cancelText ? data.cancelText : 'Cancel';
        if (data.minTimeString) this.setMinMaxResumeTime(new Date(data.minTimeString));
    }

    ngOnInit() {
    }

    setMinMaxResumeTime(date: Date) {
        date.setSeconds(0);
        date.setMilliseconds(0);

        const isoString = moment(date).toISOString(true);

        this.resumeDate = isoString;
        this.minTimeIsoString = isoString;

        date.setFullYear(date.getFullYear() + 1);

        this.maxTimeIsoString = moment(date).toISOString(true);
    }

    confirm() {
        const result: IBlindLevelAndResumeDate = {
            blindLevelToStopAt: this.blind,
            resumeDate: new Date(this.resumeDate).getTime(),
        }
        this.sopoDialogRef.close(result);
    }

    cancel () {
        this.sopoDialogRef.close(undefined);
    }
}
